import { render, staticRenderFns } from "./ServerCard.vue?vue&type=template&id=7eb85283&scoped=true&lang=pug&"
import script from "./ServerCard.vue?vue&type=script&lang=js&"
export * from "./ServerCard.vue?vue&type=script&lang=js&"
import style0 from "./ServerCard.vue?vue&type=style&index=0&id=7eb85283&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb85283",
  null
  
)

export default component.exports